import { OverlayRef } from '@angular/cdk/overlay';
import { Component, InjectionToken, OnDestroy, OnInit, inject } from '@angular/core';

import { NavigationService } from '@frontend/vanilla/core';
import { Subscription } from 'rxjs';

import { InboxComponent } from './inbox.component';

export interface InboxData {
    showBackButton: boolean;
}

export const INBOX_DATA = new InjectionToken<InboxData>('vn-inbox-data');
@Component({
    imports: [InboxComponent],
    selector: 'vn-inbox-overlay',
    templateUrl: 'inbox-overlay.html',
})
export class InboxOverlayComponent implements OnInit, OnDestroy {
    private inboxData = inject<InboxData>(INBOX_DATA);
    private overlayRef = inject(OverlayRef);
    private navigationService = inject(NavigationService);

    showBackButton: boolean;
    private locationChangeSubscription: Subscription;

    ngOnInit() {
        this.showBackButton = this.inboxData.showBackButton;
        this.locationChangeSubscription = this.navigationService.locationChange.subscribe(() => {
            this.overlayRef.detach();
        });
    }
    ngOnDestroy(): void {
        if (this.locationChangeSubscription) {
            this.locationChangeSubscription.unsubscribe();
        }
    }
}
